<template>
    <div class="h-100 slide-item ">
        <div class="mobile-composition">
            <img src="@/assets/imgs/letrero-movil.png"
                 class="logo_m animated fadeIn delay-1" alt="">

            <div class="animated slideInLeft delay-1 text-content">
                <h1 class="title bold">Reduce la velocidad</h1>
                <p class="subtitle">al manejar</p>
            </div>

            <div class="animated slideInLeft delay-1">
                <img src="https://res.cloudinary.com/kiubixdev/image/upload/v1533310403/gxsv/avt_s03.png"
                     class="avatar" alt="">
            </div>
        </div>
        <div class="web-composition">
            <img src="https://res.cloudinary.com/kiubixdev/image/upload/v1533310403/gxsv/avt_s03.png"
                 class="avatar animated slideInLeft delay-1" alt="">

            <img src="https://res.cloudinary.com/kiubixdev/image/upload/v1538450400/icon_s03.png"
                 class="logo animated fadeIn delay-1" alt="">

            <div class="animated slideInLeft delay-1 text-content">
                <h1 class="title bold">Reduce la velocidad</h1>
                <p class="subtitle">al manejar</p>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "reducir-velocidad"
    };
</script>

<style lang="sass" scoped>
    .slide-item
        .avatar-div
            text-align: left
            height: 70%
            min-height: 1px
            max-height: 70%
            .logo_m
                display: block
                position: absolute
                bottom: 10px
                min-height: 1px
                height: auto
                max-height: 100%
                width: 50%
                right: 0
        .icon-div
            height: 30%
            min-height: 1px
            max-height: 30%
            .logo
                display: none
            .text-content
                top: 50%
                .animated
                    .title
                        font-size: 1.8em
                    .subtitle
                        font-size: 1.5em
        @media only screen and (max-width: 47.9em) and (orientation: landscape)
            .avatar-div
                text-align: left !important
                .avatar
                    left: 20%
                .logo_m
                    right: 25%
                    bottom: 0
                    width: auto
            .icon-div
                .text-content
                    text-align: right
                    max-width: calc(80%)
                    width: calc(80%)
                    right: 20%
        @media only screen and (min-width: 48em)
            .avatar-div
                text-align: center
                height: auto
                min-height: 1px
                max-height: 100%
                .logo_m
                    display: none
            .icon-div
                height: auto
                min-height: 1px
                max-height: 100%
                .logo
                    display: block
                    z-index: 1
                    width: 90%
                    max-width: 98%
                    max-height: 98%
                    height: auto
                    float: right
                .text-content
                    top: 40%
                    .animated
                        .title
                        .subtitle
        @media only screen and (min-width: 48em) and (-webkit-device-pixel-ratio: 3)
            .avatar-div
                height: 100%
            .icon-div
                height: 100%
        @media only screen and (min-width: 64em)
            .avatar-div

            .icon-div
                .text-content
                    top: 41%
                    .animated
                        .title
                            font-size: 4.5em
                        .subtitle
                            font-size: 3em
        @media only screen and (min-width: 75em)
            .avatar-div
                height: 100%
            .icon-div
                height: 100%

</style>
